import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import FTTHApplication from './components/FTTHApplication.vue'
import FTTHApplicationPage from './components/FTTHApplicationPage.vue'

import Tickets from './components/Tickets.vue'
import OrganisationApplication from './components/OrganisationApplication.vue'
import PaymentFailure from './components/PaymentFailure.vue'

import PaymentSuccess from './components/PaymentSuccess.vue'
import Success from './components/pageComponents/Success.vue'


Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
    {
        path: '/',
        name: 'FTTHApplication',
        // component: FTTHApplication,
        component: FTTHApplicationPage,
        beforeEnter: (req, res, next) => {
            next(store.dispatch("setToken", null),
                store.dispatch("setUser", null),
                store.dispatch("setIsUserLoggedIn", false))
        }
    },
    {
        path: '/success',
        name: 'Success',
        // component: FTTHApplication,
        component: Success
    },
    {
        path: '/support',
        name: 'Tickets',
        component: Tickets
    },
    {
        path: '/isp',
        name: 'OrganisationApplication',
        component: OrganisationApplication
    },
    {
        path: '/paymentFailure',
        name: 'PaymentFailure',
        component: PaymentFailure
    },
    {
        path: '/paymentSuccess',
        name: 'PaymentSuccess',
        component: PaymentSuccess
    }
]
})

